import React         from "react";

const Clr = () => {
    return (
        <div className="i-clr"></div>
    )
}

// export the newly generated component
export default Clr;


/** WEBPACK FOOTER **
 ** ./src/modules/common/Clr.js
 **/